import { StockTransaction } from "@/types/stock-transaction";

// Helper function to generate dates in the past
const daysAgo = (days: number): Date => {
  const date = new Date();
  date.setDate(date.getDate() - days);
  return date;
};

// Mock transactions for STK001 (25 transactions - to test pagination)
const stk001Transactions: StockTransaction[] = [
  {
    id: "TXN-001",
    stockItemCode: "STK001",
    date: daysAgo(2),
    type: "sales-order",
    reference: "SO-2024-045",
    quantity: -3,
    runningBalance: 45,
    sellingPrice: 1299.99,
    party: "Tech Solutions Ltd",
    notes: "Bulk order for corporate client",
  },
  {
    id: "TXN-002",
    stockItemCode: "STK001",
    date: daysAgo(5),
    type: "purchase-order",
    reference: "PO-2024-123",
    quantity: 10,
    runningBalance: 48,
    costPrice: 1050.0,
    party: "Dell Distribution UK",
    notes: "Regular stock replenishment",
  },
  {
    id: "TXN-003",
    stockItemCode: "STK001",
    date: daysAgo(8),
    type: "sales-order",
    reference: "SO-2024-042",
    quantity: -2,
    runningBalance: 38,
    sellingPrice: 1299.99,
    party: "ABC Corporation",
    notes: "Standard sale",
  },
  {
    id: "TXN-004",
    stockItemCode: "STK001",
    date: daysAgo(12),
    type: "stock-take",
    reference: "ST-2024-008",
    quantity: 1,
    runningBalance: 40,
    notes: "Stock take adjustment - found additional unit in storage",
  },
  {
    id: "TXN-005",
    stockItemCode: "STK001",
    date: daysAgo(15),
    type: "stock-adjustment",
    reference: "ADJ-2024-015",
    quantity: -1,
    runningBalance: 39,
    costPrice: 1050.0,
    notes: "Damaged during warehouse operations - written off",
  },
  {
    id: "TXN-006",
    stockItemCode: "STK001",
    date: daysAgo(18),
    type: "sales-order",
    reference: "SO-2024-038",
    quantity: -5,
    runningBalance: 40,
    sellingPrice: 1299.99,
    party: "Enterprise Systems Inc",
    notes: "Large corporate order",
  },
  {
    id: "TXN-007",
    stockItemCode: "STK001",
    date: daysAgo(22),
    type: "stock-transfer",
    reference: "TRF-2024-011",
    quantity: -3,
    runningBalance: 45,
    party: "Warehouse B",
    notes: "Transfer to retail location for display units",
  },
  {
    id: "TXN-008",
    stockItemCode: "STK001",
    date: daysAgo(25),
    type: "purchase-order",
    reference: "PO-2024-115",
    quantity: 15,
    runningBalance: 48,
    costPrice: 1045.0,
    party: "Dell Distribution UK",
    notes: "Quarterly bulk purchase",
  },
  {
    id: "TXN-009",
    stockItemCode: "STK001",
    date: daysAgo(30),
    type: "sales-order",
    reference: "SO-2024-032",
    quantity: -4,
    runningBalance: 33,
    sellingPrice: 1299.99,
    party: "Digital Workspace Ltd",
    notes: "Office upgrade project",
  },
  {
    id: "TXN-010",
    stockItemCode: "STK001",
    date: daysAgo(35),
    type: "stock-adjustment",
    reference: "ADJ-2024-012",
    quantity: 2,
    runningBalance: 37,
    costPrice: 1050.0,
    notes: "Stocktake adjustment - found additional units",
  },
  {
    id: "TXN-011",
    stockItemCode: "STK001",
    date: daysAgo(40),
    type: "sales-order",
    reference: "SO-2024-028",
    quantity: -6,
    runningBalance: 35,
    sellingPrice: 1299.99,
    party: "Tech Solutions Ltd",
    notes: "Repeat customer order",
  },
  {
    id: "TXN-012",
    stockItemCode: "STK001",
    date: daysAgo(45),
    type: "purchase-order",
    reference: "PO-2024-098",
    quantity: 20,
    runningBalance: 41,
    costPrice: 1040.0,
    party: "Dell Distribution UK",
    notes: "Pre-season stock buildup",
  },
  {
    id: "TXN-013",
    stockItemCode: "STK001",
    date: daysAgo(50),
    type: "stock-take",
    reference: "ST-2024-003",
    quantity: -2,
    runningBalance: 21,
    notes: "Stock take adjustment - discrepancy found, units missing",
  },
  {
    id: "TXN-014",
    stockItemCode: "STK001",
    date: daysAgo(55),
    type: "sales-order",
    reference: "SO-2024-022",
    quantity: -3,
    runningBalance: 23,
    sellingPrice: 1299.99,
    party: "ABC Corporation",
    notes: "Standard sale",
  },
  {
    id: "TXN-015",
    stockItemCode: "STK001",
    date: daysAgo(60),
    type: "stock-transfer",
    reference: "TRF-2024-007",
    quantity: 5,
    runningBalance: 26,
    party: "Warehouse C",
    notes: "Received from overflow storage",
  },
  {
    id: "TXN-016",
    stockItemCode: "STK001",
    date: daysAgo(65),
    type: "purchase-order",
    reference: "PO-2024-085",
    quantity: 12,
    runningBalance: 21,
    costPrice: 1055.0,
    party: "Dell Distribution UK",
    notes: "Regular restock",
  },
  {
    id: "TXN-017",
    stockItemCode: "STK001",
    date: daysAgo(70),
    type: "sales-order",
    reference: "SO-2024-018",
    quantity: -7,
    runningBalance: 9,
    sellingPrice: 1299.99,
    party: "Enterprise Systems Inc",
    notes: "Large order for new office setup",
  },
  {
    id: "TXN-018",
    stockItemCode: "STK001",
    date: daysAgo(75),
    type: "stock-take",
    reference: "ST-2024-004",
    quantity: 1,
    runningBalance: 16,
    notes: "Stock take adjustment - unit found in returns area",
  },
  {
    id: "TXN-019",
    stockItemCode: "STK001",
    date: daysAgo(80),
    type: "purchase-order",
    reference: "PO-2024-072",
    quantity: 10,
    runningBalance: 15,
    costPrice: 1060.0,
    party: "Dell Distribution UK",
    notes: "Initial stock order",
  },
  {
    id: "TXN-020",
    stockItemCode: "STK001",
    date: daysAgo(85),
    type: "sales-order",
    reference: "SO-2024-012",
    quantity: -2,
    runningBalance: 5,
    sellingPrice: 1299.99,
    party: "Tech Solutions Ltd",
    notes: "Early adopter sale",
  },
  {
    id: "TXN-021",
    stockItemCode: "STK001",
    date: daysAgo(90),
    type: "stock-adjustment",
    reference: "ADJ-2024-005",
    quantity: -1,
    runningBalance: 7,
    costPrice: 1060.0,
    notes: "Demo unit damaged - written off",
  },
  {
    id: "TXN-022",
    stockItemCode: "STK001",
    date: daysAgo(95),
    type: "purchase-order",
    reference: "PO-2024-065",
    quantity: 8,
    runningBalance: 8,
    costPrice: 1065.0,
    party: "Dell Distribution UK",
    notes: "Launch stock",
  },
  {
    id: "TXN-023",
    stockItemCode: "STK001",
    date: daysAgo(100),
    type: "stock-transfer",
    reference: "TRF-2024-002",
    quantity: -3,
    runningBalance: 0,
    party: "Retail Store",
    notes: "Transfer for showroom display",
  },
  {
    id: "TXN-024",
    stockItemCode: "STK001",
    date: daysAgo(105),
    type: "purchase-order",
    reference: "PO-2024-058",
    quantity: 3,
    runningBalance: 3,
    costPrice: 1070.0,
    party: "Dell Distribution UK",
    notes: "Pre-launch sample order",
  },
  {
    id: "TXN-025",
    stockItemCode: "STK001",
    date: daysAgo(110),
    type: "purchase-order",
    reference: "PO-2024-050",
    quantity: 0,
    runningBalance: 0,
    costPrice: 1070.0,
    party: "Dell Distribution UK",
    notes: "Initial setup - no stock received yet",
  },
];

// Mock transactions for STK002 (5 transactions)
const stk002Transactions: StockTransaction[] = [
  {
    id: "TXN-026",
    stockItemCode: "STK002",
    date: daysAgo(3),
    type: "sales-order",
    reference: "SO-2024-044",
    quantity: -10,
    runningBalance: 120,
    sellingPrice: 249.5,
    party: "Office Interiors Ltd",
    notes: "Bulk furniture order",
  },
  {
    id: "TXN-027",
    stockItemCode: "STK002",
    date: daysAgo(10),
    type: "purchase-order",
    reference: "PO-2024-120",
    quantity: 30,
    runningBalance: 130,
    costPrice: 180.0,
    party: "Furniture Direct Ltd",
    notes: "Quarterly restock",
  },
  {
    id: "TXN-028",
    stockItemCode: "STK002",
    date: daysAgo(20),
    type: "stock-adjustment",
    reference: "ADJ-2024-018",
    quantity: -5,
    runningBalance: 100,
    costPrice: 180.0,
    notes: "Damaged in transit - insurance claim filed",
  },
  {
    id: "TXN-029",
    stockItemCode: "STK002",
    date: daysAgo(35),
    type: "sales-order",
    reference: "SO-2024-030",
    quantity: -15,
    runningBalance: 105,
    sellingPrice: 249.5,
    party: "Corporate Spaces Inc",
    notes: "Office refurbishment project",
  },
  {
    id: "TXN-030",
    stockItemCode: "STK002",
    date: daysAgo(50),
    type: "purchase-order",
    reference: "PO-2024-095",
    quantity: 50,
    runningBalance: 120,
    costPrice: 175.0,
    party: "Furniture Direct Ltd",
    notes: "Initial large stock order",
  },
];

// Mock transactions for STK003 (6 transactions)
const stk003Transactions: StockTransaction[] = [
  {
    id: "TXN-031",
    stockItemCode: "STK003",
    date: daysAgo(1),
    type: "sales-order",
    reference: "SO-2024-046",
    quantity: -50,
    runningBalance: 450,
    sellingPrice: 5.99,
    party: "Office Supplies Direct",
    notes: "Regular customer order",
  },
  {
    id: "TXN-032",
    stockItemCode: "STK003",
    date: daysAgo(7),
    type: "purchase-order",
    reference: "PO-2024-125",
    quantity: 200,
    runningBalance: 500,
    costPrice: 3.5,
    party: "Paper Mills Ltd",
    notes: "Monthly restock",
  },
  {
    id: "TXN-033",
    stockItemCode: "STK003",
    date: daysAgo(15),
    type: "sales-order",
    reference: "SO-2024-040",
    quantity: -100,
    runningBalance: 300,
    sellingPrice: 5.99,
    party: "Schools Supply Co",
    notes: "Back to school bulk order",
  },
  {
    id: "TXN-034",
    stockItemCode: "STK003",
    date: daysAgo(25),
    type: "stock-transfer",
    reference: "TRF-2024-012",
    quantity: 50,
    runningBalance: 400,
    party: "Warehouse B",
    notes: "Received from overflow storage",
  },
  {
    id: "TXN-035",
    stockItemCode: "STK003",
    date: daysAgo(40),
    type: "purchase-order",
    reference: "PO-2024-100",
    quantity: 150,
    runningBalance: 350,
    costPrice: 3.75,
    party: "Paper Mills Ltd",
    notes: "Regular restock",
  },
  {
    id: "TXN-036",
    stockItemCode: "STK003",
    date: daysAgo(60),
    type: "purchase-order",
    reference: "PO-2024-080",
    quantity: 200,
    runningBalance: 200,
    costPrice: 3.6,
    party: "Paper Mills Ltd",
    notes: "Initial stock order",
  },
];

// Combine all transactions
export const mockTransactions: StockTransaction[] = [
  ...stk001Transactions,
  ...stk002Transactions,
  ...stk003Transactions,
];

// Helper function to get transactions for a specific stock item
export const getTransactionsByStockCode = (stockCode: string): StockTransaction[] => {
  return mockTransactions
    .filter((txn) => txn.stockItemCode === stockCode)
    .sort((a, b) => b.date.getTime() - a.date.getTime()); // Most recent first
};

// Helper function to get transaction count for a stock item
export const getTransactionCount = (stockCode: string): number => {
  return mockTransactions.filter((txn) => txn.stockItemCode === stockCode).length;
};
